/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import identity from 'transmute/identity';
import { createAction } from 'flux-actions';
import { checkForAuth } from '../api/HubSpotAuthApi';
import ViewerRecord from '../records/ViewerRecord';
import { VIEWER_IDENTIFIED, VIEWER_FINISHED } from 'documents-lib/js/constants/ActionTypes';

const requireViewerInfoPrompt = () => import(
/* webpackChunkName: "view-secondary-content" */
'../components/view/ViewerInfoPrompt');

const createIdentifyAction = createAction(VIEWER_IDENTIFIED, identity);
const createFinishedAction = createAction(VIEWER_FINISHED, identity);
export const identifyViewer = presentation => (dispatch, getState) => {
  const {
    legalConsent,
    legalConsentFailed
  } = getState().legalConsent;
  const cachedViewer = ViewerRecord.getFromCache();

  if (legalConsentFailed) {
    dispatch(createIdentifyAction(ViewerRecord.createEmpty()));
    return;
  }

  if (legalConsent && legalConsent.deckLegalConsentEnabled) {
    if (cachedViewer && ViewerRecord.hasEmail(cachedViewer)) {
      dispatch(createIdentifyAction(cachedViewer));
      return;
    }

    requireViewerInfoPrompt().then(ViewerInfoPrompt => ViewerInfoPrompt.open({
      legalConsent,
      givenName: presentation.user.firstName,
      familyName: presentation.user.lastName,
      accessId: presentation.accessId,
      presentationId: presentation.id
    })).then(viewerInfo => {
      dispatch(createIdentifyAction(ViewerRecord.create(viewerInfo)));
    });
    return;
  }

  checkForAuth().then(auth => {
    const authViewer = ViewerRecord.createFromAuth(auth);

    if (cachedViewer && ViewerRecord.equals(cachedViewer, authViewer)) {
      dispatch(createIdentifyAction(cachedViewer));
      return;
    }

    dispatch(createIdentifyAction(authViewer));
    return;
  }, () => {
    if (cachedViewer && ViewerRecord.hasEmail(cachedViewer)) {
      dispatch(createIdentifyAction(cachedViewer));
      return;
    }

    if (presentation.skipForm) {
      if (cachedViewer) {
        dispatch(createIdentifyAction(cachedViewer));
        return;
      }

      dispatch(createIdentifyAction(ViewerRecord.createEmpty()));
      return;
    }

    if (!presentation.hasActivity) {
      dispatch(createIdentifyAction(ViewerRecord.create({
        vid: presentation.sharedWithVid
      })));
      return;
    }

    requireViewerInfoPrompt().then(ViewerInfoPrompt => ViewerInfoPrompt.open({
      givenName: presentation.user.firstName,
      familyName: presentation.user.lastName
    })).then(viewerInfo => {
      dispatch(createIdentifyAction(ViewerRecord.create(viewerInfo)));
    });
  }).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const finishActivity = () => dispatch => {
  dispatch(createFinishedAction());
  const date = new Date();
  let curDate = new Date();

  while (curDate - date < 250) {
    curDate = new Date();
  }
};